import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 5l16 -2","key":"svg-0"}],["path",{"d":"M12 4v10","key":"svg-1"}],["path",{"d":"M6.894 8h10.306c2.45 3 2.45 9 -.2 12h-10.106c-2.544 -3 -2.544 -9 0 -12","key":"svg-2"}],["path",{"d":"M5 14h14","key":"svg-3"}]]

const IconAerialLift = createReactComponent('outline', 'aerial-lift', 'AerialLift', __iconNode);

export default IconAerialLift;